import {makeAutoObservable, observable, computed, action} from "mobx";

import StoreBrands from './store-brands';
import StoreUi from './store-ui';

class StoreRoot {
    constructor() {
        this.storeBrands = new StoreBrands(this);
        this.storeUi = new StoreUi(this);
    }
}

export default StoreRoot;